import pagesAuthInvitationEn from "./invitation/default";

const pagesAuthEn = {
  common: {
    quote:
      "DRESS CODE works for workforce, product value and deal of your organization. Lead to workforce optimization.",
    email: "Email",
    password: "Password",
    termOfService: "Terms of Service",
    privacyPolicy: "Privacy Policy",
  },
  /**
   * @note Since we use amplify instead of the dresscode-backend server,
   * we cannot use the handling specified in lib/api/error.ts, so we define auth error messages as an exception
   */
  unknownError: "An error occurred",
  signIn: {
    pageTitle: "Sign in to DRESS CODE",
    title: "Sign In",
    description:
      "Organize every workflow so that anyone can execute them comfortably and naturally.",
    instruction: "Enter your Email and password to sign in",
    warning:
      "By clicking continue, you agree to our\n<termsOfUseLink>Terms of Service</termsOfUseLink> and <privacyPolicyLink>Privacy Policy</privacyPolicyLink>.",
    invalidEmailPasswordError: "Invalid username or password",
    tooManyAttemptsError: "Too many attempts. Please try again later.",
    submitButton: "Sign In",
    forgotPassword: "Forgot password?",
  },
  request: {
    pageTitle: "Request reset password",
    title: "Reset your password",
    instruction: "Enter your Email to reset your password",
    successfulMessage: "Password reset request successful.",
    incorrectEmailError: "Email is incorrect.",
    submitButton: "Reset Password",
  },
  reset: {
    pageTitle: "Request reset password",
    requestVerify: {
      title: "Forgot Password?",
      description:
        "Enter your email address and we'll send you a verification code to reset your password.",
      backToSignIn: "Back to <Link to='/auth' className=''>Sign in</Link>",
      email: "Email",
      sendButton: "Send",
      limitExceededError:
        "The reset password limit has been exceeded. Please try again later.",
      userNotFoundError: "User not found.",
      successMessage: "Password reset email has been sent",
      successDescription:
        "If you don't receive the email, the user may not be registered or not yet verified. Please contact your administrator.",
    },
    resetPassword: {
      title: "Verify Your Account",
      verificationCode: "Verification Code",
      verificationCodeDescription:
        "Enter the verification code that was sent to your email.",
      newPassword: "New Password",
      newPasswordDescription: "Enter the new password to change your password.",
      newPasswordPlaceholder: "password",
      showPassword: "Show password",
      verifyButton: "Verify",
      didNotReceiveCode: "Didn't get email?",
      resendCode: "Resend Code",
      codeMismatchError: "The verification code is incorrect.",
      invalidPasswordError:
        "Use a password at least 10 characters long with alphanumeric characters (including upper and lower case letters) and symbols.",
      limitExceededError:
        "The reset password limit has been exceeded. Please try again later.",
      successMessage:
        "Your password was reset successfully. You are now signed in.",
    },
  },
  mfa: {
    email: {
      title: "Check Your Email",
      notReceivedCode: "Didn't receive an email? ",
    },
    resendSignInCode: {
      successResendSignInCodeMessage: "Authentication code resent.",
      successResendSignInCodeDescription: "Check your email for the new code.",
      errorResendSignInCodeMessage: "Failed to resend authentication code.",
      errorResendSignInCodeDescription: "Please try again.",
    },
    description: "Enter the six digit-code",
    codeLabel: "Authentication code",
    instruction: "Enter the code displayed in the authentication app",
    label: "mfa",
    error: {
      invalid: "The authentication code is incorrect.",
      expired: "The authentication code has expired.",
      codeDeliveryFailure: "Failed to send verification code.",
    },
    submitButton: "Verify",
    resendLink: "Resend",
  },
  invitation: pagesAuthInvitationEn,
};

export default pagesAuthEn;
